/* HOTTLE — vanilla behaviour layer.
   No libraries. Everything here enhances markup that already works without JS. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* --- Scroll reveal, staggered per group ------------------------------- */
  function initReveal() {
    var nodes = document.querySelectorAll('[data-ht-reveal]:not(.is-in)');
    if (!nodes.length) return;
    if (reduce.matches || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      var batch = entries.filter(function (e) { return e.isIntersecting; });
      batch.forEach(function (entry, i) {
        entry.target.style.setProperty('--ht-delay', (i * 60) + 'ms');
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    // Anything already on screen is shown immediately, with no delay and no
    // observer round-trip. A product card whose top is visible but whose body
    // runs past the fold never reaches the 6% threshold, so on a 375px phone a
    // whole collection grid could sit at opacity:0 until the user scrolled —
    // which looked like an empty page. Only genuinely below-the-fold content
    // gets the scroll-reveal treatment.
    //
    // READ every position first, THEN write any class. Interleaving the two
    // (measure one node, add `is-in`, measure the next) invalidates style on
    // every add, so each following getBoundingClientRect() forced a fresh
    // layout of the whole page: PageSpeed timed that loop at ~700 ms of
    // forced reflow on the Trimmer page (2.000+ elements), on a phone-class
    // CPU, before the page could respond. `is-in` only changes opacity and
    // transform, which never move another node, so measuring up front gives
    // exactly the same answers for the price of one layout.
    var vh = window.innerHeight || 800;
    var tops = [];
    nodes.forEach(function (n) { tops.push(n.getBoundingClientRect().top); });
    nodes.forEach(function (n, i) {
      if (tops[i] < vh * 0.95) {
        n.classList.add('is-in');
      } else {
        io.observe(n);
      }
    });
  }

  /* --- Sticky add-to-cart bar (buyable PDP, mobile) --------------------- */
  function initStickyAtc() {
    // one bar, whichever state the product is in (cart or eMAG)
    var bar = document.querySelector('[data-ht-sticky-atc]');
    if (!bar) return;
    var anchor = document.querySelector('[data-ht-atc-anchor]');
    if (!anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        // show the bar once the real button has scrolled out of view upwards
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.setAttribute('data-visible', past ? 'true' : 'false');
      });
    }, { threshold: 0 });
    io.observe(anchor);

    bar.addEventListener('click', function (ev) {
      var trigger = ev.target.closest('[data-ht-sticky-submit]');
      if (!trigger) return;
      ev.preventDefault();
      var form = anchor.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      var submit = form.querySelector('[type="submit"]');
      if (submit) submit.click(); else form.submit();
    });
  }

  /* --- Free shipping progress ------------------------------------------- */
  function money(cents) {
    // RON, comma decimal, lowercase lei — matches the rest of the storefront
    return (cents / 100).toFixed(2).replace('.', ',') + ' lei';
  }

  function paintFreeship(cart) {
    var els = document.querySelectorAll('[data-ht-freeship]');
    if (!els.length) return;
    // Free delivery is counted in DEVICES, not lei: accessories do not count.
    // Same test as snippets/hottle-freeship.liquid — keep the two in step.
    var devices = 0;
    (cart.items || []).forEach(function (i) {
      var t = String(i.product_type || '').toLowerCase();
      if (t.indexOf('accesoriu') === -1) devices += i.quantity || 0;
    });
    els.forEach(function (el) {
      var need = parseInt(el.getAttribute('data-need'), 10);
      if (!need || isNaN(need)) return;
      var remaining = Math.max(0, need - devices);
      var pct = Math.min(100, need ? (devices / need) * 100 : 0);
      var bar = el.querySelector('[data-ht-freeship-bar]');
      var txt = el.querySelector('[data-ht-freeship-text]');
      if (bar) {
        bar.style.width = pct + '%';
        var track = bar.parentElement;
        if (track) {
          track.setAttribute('role', 'progressbar');
          track.setAttribute('aria-valuemin', '0');
          track.setAttribute('aria-valuemax', '100');
          track.setAttribute('aria-valuenow', String(Math.round(pct)));
        }
      }
      if (txt) {
        txt.innerHTML = remaining > 1
          ? 'Mai adaugă <b>' + remaining + ' aparate</b> și livrarea e gratuită.'
          : remaining === 1
            ? 'Mai adaugă <b>un aparat</b> și livrarea e gratuită.'
            : '<b>Livrare gratuită</b> — ai ' + devices + ' aparate în coș.';
      }
    });
  }

  function refreshFreeship() {
    if (!document.querySelector('[data-ht-freeship]')) return;
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) paintFreeship(c); })
      .catch(function () { /* leave the server-rendered value in place */ });
  }

  function initFreeship() {
    refreshFreeship();
    // Dawn publishes cart updates on its pub/sub bus; fall back to fetch events.
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, refreshFreeship);
    }
    document.addEventListener('cart:refresh', refreshFreeship);
  }

  /* --- Notify me: enhance the native form, never replace it -------------- */
  function initNotify() {
    document.querySelectorAll('[data-ht-notify]').forEach(function (wrap) {
      var form = wrap.querySelector('form');
      var msg = wrap.querySelector('[data-ht-notify-msg]');
      if (!form || !msg) return;
      form.addEventListener('submit', function () {
        // Native POST still happens; this is just immediate feedback.
        var btn = form.querySelector('[type="submit"]');
        if (btn) { btn.setAttribute('aria-disabled', 'true'); }
        msg.setAttribute('data-state', 'pending');
        msg.textContent = 'Se trimite…';
      });
    });
  }

  /* --- eMAG click-out signal (for GA4 / Meta, if present) --------------- */
  function initEmagTracking() {
    document.addEventListener('click', function (ev) {
      var a = ev.target.closest('[data-ht-emag]');
      if (!a) return;
      var payload = {
        item_id: a.getAttribute('data-pnk') || '',
        item_name: a.getAttribute('data-title') || '',
        link_url: a.href
      };
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'emag_click_out', payload);
      }
      if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', 'eMAGClickOut', payload);
      }
    });
  }

  // A decorative animation must never be able to hide the page. Each init is
  // isolated, and a failsafe force-reveals anything still hidden shortly after
  // load — so if any of this ever throws, the visitor still sees a full site.
  function safely(fn, label) {
    try { fn(); } catch (err) {
      if (window.console && console.warn) console.warn('[hottle] ' + label + ' failed', err);
    }
  }

  function revealAllRemaining() {
    document.querySelectorAll('[data-ht-reveal]:not(.is-in)').forEach(function (n) {
      n.classList.add('is-in');
    });
  }

  function boot() {
    safely(initReveal, 'reveal');
    safely(initStickyAtc, 'sticky-atc');
    safely(initFreeship, 'freeship');
    safely(initNotify, 'notify');
    safely(initEmagTracking, 'emag-tracking');

    // Backstops: whichever fires first wins.
    window.setTimeout(revealAllRemaining, 1500);
    window.addEventListener('scroll', function once() {
      window.removeEventListener('scroll', once);
      window.setTimeout(revealAllRemaining, 400);
    }, { passive: true, once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', boot);
})();

/* --- Mobile drawer (appended: header behaviour) -------------------------- */
(function () {
  'use strict';
  function initDrawer() {
    var drawer = document.querySelector('[data-ht-drawer]');
    var openBtn = document.querySelector('[data-ht-drawer-open]');
    if (!drawer || !openBtn || drawer.dataset.htBound === '1') return;

    /* ── Portal the drawer to <body> ──────────────────────────────────────
       `position:fixed` is resolved against the nearest ancestor that has a
       transform, filter, backdrop-filter, perspective, contain:paint — or
       `will-change` naming any of those. Twice now an ancestor has quietly
       become one and shrunk this drawer to the size of the header:

         3 aug — `backdrop-filter` on .ht-hdr (the glass header)
         5 aug — `will-change:transform` on .shopify-section-group-header
                  (V4's hide-on-scroll header)

       Moving it out of the header markup fixed the first one and did not fix
       the second, because the section GROUP wrapper is still an ancestor and
       Shopify owns that element. So stop relying on where the markup sits:
       reparent to <body> at runtime, where nothing can wrap it. Any future
       CSS on the header is then harmless by construction. */
    if (drawer.parentElement !== document.body) {
      var stale = document.body.querySelector(':scope > [data-ht-drawer]');
      if (stale && stale !== drawer) stale.remove();
      document.body.appendChild(drawer);
    }

    drawer.dataset.htBound = '1';

    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      // Force a synchronous layout flush so the transition has a start value.
      // rAF would also work, but rAF is throttled when the tab is not being
      // painted — and a callback that never fires leaves the drawer open in
      // the DOM, invisible on screen, with body scroll locked.
      void drawer.offsetWidth;
      drawer.setAttribute('data-open', 'true');
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('ht-noscroll');
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    }

    function close() {
      drawer.removeAttribute('data-open');
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('ht-noscroll');
      window.setTimeout(function () { drawer.hidden = true; }, 300);
      if (lastFocus) lastFocus.focus();
    }

    openBtn.addEventListener('click', open);
    drawer.querySelectorAll('[data-ht-drawer-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.hasAttribute('data-open')) close();
    });
    // keep focus inside the drawer while it is open
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !drawer.hasAttribute('data-open')) return;
      var f = drawer.querySelectorAll('a[href], button:not([disabled])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawer, { once: true });
  } else { initDrawer(); }
  document.addEventListener('shopify:section:load', initDrawer);
})();

/* --- Click-to-load YouTube (no player JS until the viewer asks) ---------- */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ht-video]');
    if (!btn) return;
    var id = btn.getAttribute('data-ht-video');
    if (!id) return;
    var wrap = document.createElement('div');
    wrap.className = 'ht-video__frame';
    var f = document.createElement('iframe');
    // youtube-nocookie: no tracking cookie until playback, which keeps the
    // consent banner honest for viewers who declined marketing cookies.
    f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) +
            '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
    f.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
    f.setAttribute('allowfullscreen', '');
    f.setAttribute('title', btn.getAttribute('aria-label') || 'Videoclip');
    wrap.appendChild(f);
    btn.replaceWith(wrap);
  });
})();

/* --- PDP gallery: thumbs drive the same rail the finger swipes ----------- */
(function () {
  'use strict';
  function initGallery(root) {
    var gal = root.querySelector('[data-ht-gallery]');
    if (!gal || gal.dataset.htBound === '1') return;
    gal.dataset.htBound = '1';

    var rail = gal.querySelector('[data-ht-gal-rail]');
    var slides = [].slice.call(gal.querySelectorAll('[data-ht-slide]'));
    var thumbs = [].slice.call(gal.querySelectorAll('[data-ht-thumb]'));
    var counter = gal.querySelector('[data-ht-gal-counter]');
    var prev = gal.querySelector('[data-ht-gal-prev]');
    var next = gal.querySelector('[data-ht-gal-next]');
    if (!rail || slides.length < 2) return;

    var current = 0;

    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      rail.scrollTo({ left: slides[i].offsetLeft - rail.offsetLeft, behavior: 'smooth' });
      setActive(i);
    }

    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, n) {
        var on = n === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.dataset.htThumb, 10) || 0); });
    });
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    // Keep thumbs and counter honest when the user swipes instead of clicking.
    var tick;
    rail.addEventListener('scroll', function () {
      window.clearTimeout(tick);
      tick = window.setTimeout(function () {
        var mid = rail.scrollLeft + rail.clientWidth / 2;
        var best = 0, bestDist = Infinity;
        slides.forEach(function (sl, n) {
          var c = sl.offsetLeft - rail.offsetLeft + sl.clientWidth / 2;
          var d = Math.abs(c - mid);
          if (d < bestDist) { bestDist = d; best = n; }
        });
        if (best !== current) setActive(best);
      }, 90);
    }, { passive: true });

    setActive(0);
  }

  function boot() { initGallery(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else { boot(); }
  document.addEventListener('shopify:section:load', function (e) { initGallery(e.target || document); });
})();

/* --- Category filter chips (collection grids) ----------------------------
   Progressive: the markup ships `hidden` and only this script reveals it, so
   with JS off the visitor gets the full grid instead of dead buttons. */
(function () {
  'use strict';
  function initFilters() {
    var wrap = document.querySelector('[data-ht-filters]');
    var grid = document.querySelector('[data-ht-grid]');
    if (!wrap || !grid || wrap.dataset.htBound === '1') return;
    wrap.dataset.htBound = '1';
    wrap.hidden = false;

    var empty = wrap.querySelector('[data-ht-filters-empty]');
    var chips = Array.prototype.slice.call(wrap.querySelectorAll('[data-cat-filter]'));
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-cat]'));

    function apply(cat) {
      var shown = 0;
      cards.forEach(function (c) {
        var on = cat === 'all' || c.getAttribute('data-cat') === cat;
        c.hidden = !on;
        if (on) shown++;
      });
      chips.forEach(function (b) {
        var on = b.getAttribute('data-cat-filter') === cat;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (empty) empty.hidden = shown !== 0;
      // keep the URL shareable without a reload
      try {
        var u = new URL(window.location.href);
        if (cat === 'all') u.searchParams.delete('cat'); else u.searchParams.set('cat', cat);
        window.history.replaceState({}, '', u);
      } catch (e) {}
    }

    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cat-filter]');
      if (!b) return;
      apply(b.getAttribute('data-cat-filter'));
    });

    // deep link: /collections/toate-produsele?cat=colectie-shaver
    try {
      var pre = new URL(window.location.href).searchParams.get('cat');
      if (pre && chips.some(function (b) { return b.getAttribute('data-cat-filter') === pre; })) apply(pre);
    } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilters, { once: true });
  } else { initFilters(); }
  document.addEventListener('shopify:section:load', initFilters);
})();

/* --- Bundle selector on the offer hero ----------------------------------
   Sets the quantity on the real add-to-cart form. The money is worked out by
   a Shopify automatic discount at the cart, not here — this only decides how
   many units go in, so the displayed total and the charged total can never
   disagree because of a rounding rule written twice. */
(function () {
  'use strict';
  function initOffer() {
    var scope = document.querySelector('[data-ht-offer]');
    if (!scope || scope.dataset.htBound === '1') return;
    var opts = scope.querySelector('[data-ht-offer-opts]');
    var qty = scope.querySelector('input[name="quantity"]');
    if (!opts || !qty) return;
    scope.dataset.htBound = '1';

    opts.addEventListener('change', function (e) {
      var r = e.target.closest('input[name="ht-offer-qty"]');
      if (!r) return;
      qty.value = r.value;
      var two = r.value === '2';
      var label = scope.querySelector('[type="submit"] span');
      if (label && !scope.querySelector('[type="submit"]').disabled) {
        label.textContent = two ? 'Adaugă 2 în coș' : 'Adaugă în coș';
      }
      // the sticky bar quotes the same option, so the two never disagree
      var sp = document.querySelector('[data-ht-sticky-price]');
      var sn = document.querySelector('[data-ht-sticky-note]');
      var sb = document.querySelector('[data-ht-sticky-submit] span');
      if (sp) sp.textContent = two ? sp.dataset.two : sp.dataset.one;
      if (sn) sn.textContent = two ? '2 bucăți' : '1 bucată';
      if (sb) sb.textContent = two ? 'Adaugă 2 în coș' : 'Adaugă în coș';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOffer, { once: true });
  } else { initOffer(); }
  document.addEventListener('shopify:section:load', initOffer);
})();
